import { useDropdownState } from '../abstract/dropdown';

export function useGarageFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: garage, onSelect: onGarageSelect, options: garageOptions } = useDropdownState({
    defaultOptions: config.garageOptions,
    defaultValue: query.garage || config.garageDefault,
    filterKey: `garages`,
    setFilters,
    updateQuery,
  });

  return { garage, garageOptions, onGarageSelect };
}
